
import axios from "axios"
import ApiStore from "./ApiStore";

var querystring = require('querystring');


export class StockStore extends ApiStore {
  constructor() {

    super();
  }

  loadStockConfig(completeFunc){
    axios.get('/stock/config/')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }


  loadCategory(type,completeFunc){
    
    axios.get('/stock/category/'+type)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  
  }

  loadSubCategory(type,cat_id,completeFunc){
    
    axios.get('/stock/category/'+type+'?cat_id='+cat_id)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  
  }

  loadImages(type,itemnum,completeFunc,errorFunc){
    axios.get('/stock/images/'+type+'?itemnum='+itemnum)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc(error)
    })
  }

  loadNewImages(type,itemnum,completeFunc,errorFunc){
    axios.get('/stock/product/'+type+'/'+itemnum)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc(error)
    })
  }

  loadStockCheckItem(stockType,completeFunc,errorFunc){
    axios.get('/stock/checkitem/'+stockType)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc(error)
    })
  }

  loadStockProductSerial(stockType,itemnum,completeFunc,errorFunc){
    axios.get('/stock/productserial/'+stockType+'/'+itemnum)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc(error)
    })
  }

  loadMixPaintItem(mpNo,completeFunc,errorFunc){
    axios.get('/stock/mixpaint/item?mp='+mpNo)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc(error)
    })
  }

  loadMixColorItem(mcNo,completeFunc,errorFunc){
    axios.get('/stock/mixedcolor/item?mc='+mcNo)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc(error)
    })
  }

  loadStockSerialNo(stockType,query,completeFunc,errorFunc){
    axios.get('/stock/'+stockType+'serialno/?query='+query)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc(error)
    })
  }

  loadPartTypeInfo(itemnum,cat_id,completeFunc,errorFunc){
    let url ='/stock/product/part?item_id='+itemnum+'&cat_id='+cat_id
    axios.get(url)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc(error)
    })
  }

  loadRecordDoc(id,completeFunc,errorFunc){
    axios.get('/stock/recorddoc/'+id+'?format=json')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc(error)
    })
  }

  generateProductcode(type,itemnum,part_type,cat_id,completeFunc,errorFunc){
    axios.get('/stock/productcode/'+type+'?itemnum='+itemnum+'&part_type='+part_type+'&cat_id='+cat_id)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  requestStockDecrease(soNo,itemlist,completeFunc,errorFunc){
    let postData ={item:itemlist,meta:{sale_order_no:soNo,description:'ตัดสต๊อกจากการขายหน้าร้าน '+soNo,stock_type:'genpart',type:'export'}}
    axios.post('/stock/genpart/export/',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  requestStockIncrease(poNo,itemlist,completeFunc,errorFunc){
    let postData ={item:itemlist,meta:{po:poNo,description:'เพิ่มสต๊อกจากใบสั่งซื้อ '+poNo,stock_type:'genpart',type:'import'}}
    axios.post('/stock/genpart/import/',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  requestStockAdjust(type,itemlist,completeFunc,errorFunc){
    let postData ={item:itemlist,meta:{stock_type:type,type:'adjust'}}
    console.log('postData',postData)
    axios.post('/stock/adjust/'+type+'',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  saveProduct(type,items,completeFunc,errorFunc){
    //postData = {category:'175',description:'hello',itemnum:'1',productcode:'T0001',remark:'',unit:'ชิ้น'}
    let postData = {product:items}
    if (type==='genpart')
      postData = items
    // console.log('postData=>',postData)  
    axios.post('/stock/product/'+type,postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  saveStockCheck(type,postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/stock/checkitem/'+type,postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }


  saveStockMixPaintItem(postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/stock/mixpaint/item',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  saveStockMixColorItem(postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/stock/mixedcolor/item',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  saveStockProductSerial(type,itemnum,postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/stock/productserial/'+type+'/'+itemnum,postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  saveStockBorrowing(stockType,postData,completeFunc,errorFunc){
    console.log('postData',postData)
    //postDate = {itemlist:[{borrowing_item_id:'',...}]}
    axios.post('/stock/borrowing/'+stockType,postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  saveStockUsageVolume(stockType,postData,completeFunc,errorFunc){
    console.log('postData',postData)
    //postDate = {itemlist:[{borrowing_item_id:'',...}]}
    axios.post('/stock/usagevolume/'+stockType,postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  saveCategory(type,postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/stock/newcategory/'+type,postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  saveTyreCategory(type,parent_id,postData,completeFunc,errorFunc){
    console.log('postData',postData)
    let url = '/stock/newcategory/'+type
    if (parent_id!==undefined)
      url = '/stock/newcategory/'+type+'/'+parent_id
    axios.post(url,postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  importProduct(type,postData,completeFunc,errorFunc){
    
    //postData = {{item:[{itemnum:'1',quantity:'1',description:''}]},
    //           {meta:description:'',request_by:'',response_by:'',stock_type:'',record_type:''}}
    console.log('postData',postData)
    axios.post('/stock/import/'+type,postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  exportProduct(type,postData,completeFunc,errorFunc){
    
    //postData = {{item:[{itemnum:'1',quantity:'1',description:''}]},
    //           {meta:description:'',request_by:'',response_by:'',stock_type:'',record_type:'',added_date:''}}
    console.log('postData',postData)
    axios.post('/stock/export/'+type,postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  recordDocProduct(type,postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/stock/recorddoc/'+type,postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  requestPurchaseProduct(type,postData,completeFunc,errorFunc){
    
    //postData = {{item:[{itemnum:'1',quantity:'1',description:''}]},
    //           {meta:description:'',request_by:'',response_by:'',stock_type:'',record_type:'',added_date:''}}
    console.log('postData',postData)
    axios.post('/stock/request_purchase/'+type,postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  forceUpdateQuantity(stockType,itemnum,newQuantity,completeFunc,errorFunc){

    axios.post('/stock/force_update_quantity/'+stockType+'/'+itemnum+'/'+newQuantity,{})
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  deleteProducts(stockType,itemlist,completeFunc,errorFunc){

    let reqList = itemlist.map((item,index)=>{
      return axios.delete('/stock/delete_product/'+stockType+'/'+item.itemnum)
    })

    Promise.all(reqList)
    .then((responses) => {
      console.log('result',responses)
        completeFunc({})
    }).catch(function(error){
      errorFunc({status:'error',desc:error});
    });
  }

  deleteProduct(stockType,itemnum,completeFunc,errorFunc){
    axios.delete('/stock/delete_product/'+stockType+'/'+itemnum)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  deleteStockRecord(recordid,completeFunc,errorFunc){
    axios.delete('/stock/recorddoc/'+recordid)
    .then(function(response){
      //console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      //console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  deleteCategory(itemnum,completeFunc,errorFunc){
    axios.delete('/stock/delete_category/'+itemnum)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  loadStockTransaction(type,year,month,record_type,start,length,query,pr_status,completeFunc) {
    let param_pr = ''
    if (pr_status!=='')
      param_pr = '&pr_status='+pr_status
    axios.get('/stock/transaction/'+type+'?year='+year+'&month='+month+'&record_type='+record_type+'&start='+start+'&length='+length+'&q='+query+param_pr)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadStockTransaction_(type,year,month,day,searchBy,record_type,start,length,query,pr_status,completeFunc) {
    let param_pr = ''
    if (pr_status!=='')
      param_pr = '&pr_status='+pr_status
    axios.get('/stock/transaction/'+type+'?year='+year+'&month='+month+'&day='+day+'&cat='+searchBy+'&record_type='+record_type+'&start='+start+'&length='+length+'&q='+query+param_pr)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  // loadStockTransaction_(type,year,month,day,record_type,cat,start,length,query,pr_status,completeFunc) {
  //   let param_pr = ''
  //   if (pr_status!=='')
  //     param_pr = '&pr_status='+pr_status
  //   axios.get('/stock/transaction/'+type+'?year='+year+'&month='+month+'&day='+day+'&record_type='+record_type+'&cat='+cat+'&start='+start+'&length='+length+'&q='+query+param_pr)
  //   .then(function(response){
  //     console.log(response)
  //     completeFunc(response.data)
  //   })
  //   .catch(function (error) {
  //     console.log(error);
  //   })
  // }

  // loadStockTransactionRange_(type,start_date,end_date,record_type,cat,start,length,query,pr_status,completeFunc) {
  //   let param_pr = ''
  //   if (pr_status!=='')
  //     param_pr = '&pr_status='+pr_status
  //   axios.get('/stock/transaction/'+type+'?start_date='+start_date+'&end_date='+end_date+'&record_type='+record_type+'&cat='+cat+'&start='+start+'&length='+length+'&q='+query+param_pr)
  //   .then(function(response){
  //     console.log(response)
  //     completeFunc(response.data)
  //   })
  //   .catch(function (error) {
  //     console.log(error);
  //   })
  // }

  loadStockTransactionRecord(type,itemnum,completeFunc) {
    axios.get('/stock/transaction_record/'+type+'/'+itemnum)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadStockTransactionRecordAllItem(type,year,month,day,rtype,query,completeFunc) {
    axios.get('/stock/transaction_record_allitem/'+type+'?year='+year+'&month='+month+'&day='+day+'&record_type='+rtype+'&q='+query)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadCarRegistrationNo(car_registration_no,completeFunc){
    axios.get('/workdoc/autocomplete/car_registration_no?q='+car_registration_no)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })    
  }

  loadCarRegistrationNoWithWork(car_registration_no,completeFunc){
    axios.get('/workdoc/autocomplete/car_registration_no?q='+car_registration_no+'&withwork=true')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })    
  }

  loadStockBorrowingTool(borrowing_date,completeFunc){
    axios.get('/stock/borrowing/tool?borrowing_date='+borrowing_date)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })    
  }

  loadStockBorrowingPainter(borrowing_date,completeFunc){
    axios.get('/stock/borrowing/painter?borrowing_date='+borrowing_date)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })    
  }

  loadStockUsageVolme(stockType,year,month,day,employeeId,completeFunc){
    axios.get('/stock/usagevolume/'+stockType+'?year='+year+'&month='+month+'&day='+day+'&employee_id='+employeeId)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })    
  }

  loadMixpaintItemcode(productcode,itemcode,completeFunc){
    axios.get('/stock/mixpaint_itemcode/?productcode='+productcode+'&itemcode='+itemcode)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadPartItem(no,carType,completeFunc){
    axios.get('/damage/part_item/'+no+'/all?format=json&car_type='+carType)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadMixpaintQueue(completeFunc){
    axios.get('/stock/mixpaint_queue/unfinished')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  saveMixpaintQueue(type,postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/stock/mixpaint_queue/'+type,postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  saveMixcolorType(postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/stock/mixpaint_queue/mixcolor_type',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  loadSyncStockMixedcolor(stock_type,cat_id,completeFunc){
    axios.get('/stock/sync_stock_mixedcolor/'+stock_type+'/'+cat_id)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadLastUsageVolume(stock_type,productcode,itemcode,completeFunc){
    axios.get('/stock/last_usagevolume/'+stock_type+'/'+productcode+'/'+itemcode)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadSearchProductMixpaint(stock_type,query,completeFunc){
    axios.get('/stock/searchproductmixpaint/'+stock_type+'?q='+query)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }
  
  loadSearchAnyProductDetail(query,completeFunc){
    axios.get('/stock/anyproductdetail?query='+query)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadSearchAnyProductCode(query,completeFunc){
    axios.get('/stock/anyproductcode?query='+query)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }


  loadWarehouse(completeFunc){
    axios.get('/stock/warehouse')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  saveWarehouse(postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/stock/warehouse/',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  deleteWarehouse(warehouse_id,completeFunc,errorFunc){
    axios.delete('/stock/warehouse/'+warehouse_id)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  loadProductStockCard(stockType,itemnum,year,month,day,completeFunc) {
    year = year-543
    axios.get('/stock/product_stock_card/'+stockType+'/'+itemnum+'?year='+year+'&month='+month+'&day='+day)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadProductStockCardRange(stockType,itemnum,start_date,end_date,completeFunc){
    axios.get('/stock/product_stock_card/'+stockType+'/'+itemnum+'?start_date='+start_date+'&end_date='+end_date)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadProductJobcardRecord(itemnum,completeFunc) {
    axios.get('/stock/product_jobcard_record/'+itemnum)
    .then(function (response) {
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadProductPORecord(itemnum,completeFunc) {
    axios.get('/stock/product_purchase_order_record/'+itemnum)
    .then(function (response) {
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadProductCostFifoRecord(itemnum,completeFunc) {
    axios.get('/stock/product_cost_fifo_record/'+itemnum)
    .then(function (response) {
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  updatePRStatus(recordid,status,completeFunc,errorFunc){
    axios.post('/stock/purchaserequest_status/'+recordid+'/'+status)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  updatePRComplete(recordid,completeFunc,errorFunc){
    axios.post('/stock/purchaserequest_complete/'+recordid)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  loadStockSpecifications(start,length,completeFunc) {
    axios.get('/stock/specifications?start='+start+'&length='+length)
    .then(function (response) {
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadStockSpecificationItem(itemnum,completeFunc) {
    axios.get('/stock/specification/'+itemnum)
    .then(function (response) {
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  saveStockSpecificationItem(postData,completeFunc,errorFunc){
    axios.post('/stock/specification/'+postData.spec.itemnum, postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  loadMasterData(completeFunc){
    axios.get('/stock/masterdata')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  saveMasterData(postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/stock/masterdata',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  saveProductLocationConfig(postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/stock/product_location_config',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  } 

  loadLocationShelf(q,completeFunc){
    axios.get('/stock/location_shelf?q='+q)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadBusinessUnit(completeFunc){
    axios.get('/stock/business_unit')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  saveBusinessUnit(business_unit_id,postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/stock/business_unit/'+business_unit_id,postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  } 

  deleteBusinessUnit(business_unit_id,completeFunc,errorFunc){
    axios.delete('/stock/business_unit/'+business_unit_id)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  loadSubBusinessUnit(bu_code,completeFunc){
    axios.get('/stock/sub_business_unit?bu_code='+bu_code)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  saveSubBusinessUnit(business_unit_id,postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/stock/sub_business_unit/'+business_unit_id,postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  } 

  deleteSubBusinessUnit(business_unit_id,completeFunc,errorFunc){
    axios.delete('/stock/sub_business_unit/'+business_unit_id)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  loadSpecifications(q,completeFunc,errorFunc){
    axios.get('/stock/specifications/?q='+q+'&field=productcode')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc(error)
    })
  }

  loadConfigPrReportTable(param,completeFunc){
    axios.get('/stock/config_report_table/'+param)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  } 

  saveConfigPrReportTable(param,postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/stock/config_report_table/'+param,postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  loadStockNewRecordDoc(completeFunc){
    axios.get('/stock/new_record_doc')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

}

export default new StockStore()



// WEBPACK FOOTER //
// ./src/stores/StockStore.js